<template>
  <AudienceIntentPage :page="page" />
</template>

<script setup lang="ts">
import { getAudienceSeoPage } from '~/utils/audienceSeoPages'

definePageMeta({
  layout: 'editorial',
  headerOnDark: true
})

const page = getAudienceSeoPage('chaussuresLuxeClientesPriveesFr')
</script>
